// import { Switch } from "antd";
import moment from "moment";

/**
 * createColumns
 * Complemento para mostrar las tablas tanto como en antd y modo responsive
 * @param {Function} showEditModal
 * @param {Function} showDeleteModal
 * @param {Number} page
 */
export function createColumns(page = 1, onChangeState = null, porSedeEnabled = false) {
  const columns = [
    {
      title: "N.º",
      key: "index",
      render: (value, item, index) => (page - 1) * 10 + index + 1
    },
    {
      title: "Tipo",
      dataIndex: "tipoparticipante",
      key: "tipoparticipante",
      sorter: (a, b) => a.tipoparticipante.localeCompare(b.tipoparticipante),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "DNI",
      dataIndex: "nrodocumento",
      key: "nrodocumento",
      sorter: (a, b) => a.nrodocumento.localeCompare(b.nrodocumento),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
      sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Apellido",
      dataIndex: "apellido",
      key: "apellido",
      sorter: (a, b) => a.apellido.localeCompare(b.apellido),
      sortDirections: ["descend", "ascend"]
    },
    // {
    //   title: "Modalidad",
    //   dataIndex: "tipoparticipacion",
    //   key: "tipoparticipacion",
    //   sorter: (a, b) => a.tipoparticipacion.localeCompare(b.tipoparticipacion),
    //   sortDirections: ["descend", "ascend"]
    // },
    {
      title: "Asistió",
      dataIndex: "asistio",
      key: "asistio",
      render: (asistio) => {
        if (!asistio) return <p></p>;
        return <p className="font-bold">SÍ</p>;
      },
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Carnet",
      dataIndex: "carnet",
      key: "carnet",
      render: (carnet) => {
        if (!carnet) return <p></p>;
        return <p className="font-bold text-blue-500">✓</p>;
      },
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Hora",
      dataIndex: "horaasistio",
      key: "horaasistio",
      render: (horaasistio) => {
        if (!horaasistio) return <p></p>;
        return <p>{moment(horaasistio).format("hh:mm A")}</p>;
      },
      sortDirections: ["descend", "ascend"]
    }
    // borrar asistencia
    // {
    //   title: "Acciones",
    //   key: "action",
    //   render: (record) => (
    //     <Switch size="small" checked={record.activo} onChange={() => onChangeState(record)} />
    //   )
    // }
  ];

  if (porSedeEnabled) {
    columns.splice(3, 0, {
      title: "Sede",
      dataIndex: "sede",
      key: "sede",
      sorter: (a, b) => (a.sede || "").localeCompare(b.sede || "")
    });
  }

  return columns;
}
